import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { acceptProposedChallenge, editProposedChallenge, getChallengeCategoryList, getChallengeList, getEcoQuizList, getProposedChallengeDetails } from "../api/challenge";

export const useProposedChallengeMutation = () => {
    const queryClient = useQueryClient();
    
    return useMutation({
        mutationKey: ['proposedChallengesStatus'],
        mutationFn: (data) => acceptProposedChallenge(data),
        onSuccess: () => {
            queryClient.invalidateQueries(['proposedChallenges']);
        },
    });
}

export const useGetProposedChallengeDetails = (id) => {
    return useQuery({
        queryKey: ['proposedChallengeDetails', id],
        queryFn: () => getProposedChallengeDetails(id),
    });
}

export const useGetChallengeCategoriesList = () => {
    return useQuery({
        queryKey: ['challengeCategories'],
        queryFn: () => getChallengeCategoryList(),
    });
}

export const useUpdateProposedChallenge = (id) => {
    const queryClient = useQueryClient();
    
    return useMutation({
        mutationKey: ['updateProposedChallenge'],
        mutationFn: (data) => editProposedChallenge(data),
        onSuccess: () => {
            queryClient.invalidateQueries(['proposedChallengeDetails', id]);
        }
    });
}

export const useGetChallengeList = () => {
    return useQuery({
        queryKey: ['challengeList'],
        queryFn: () => getChallengeList(),
    });
}

export const useGetEcoQuiz = () => {
    return useQuery({
        queryKey: ['eco-quiz-list'],
        queryFn: () => getEcoQuizList(),
    });
}